export const BASE_API_URL = `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_VERSION}`;
export const BASE_SCOPE_API_URL = `${process.env.REACT_APP_BASE_SCOPE_API_URL}${process.env.REACT_APP_API_VERSION}`;

export const BASE_API_V2_URL = `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_V2}`;
export const BASE_SCOPE_API_V2 = `${process.env.REACT_APP_BASE_SCOPE_API_URL}${process.env.REACT_APP_API_V2}`;

export const EWAY_CLIENT_KEY = process.env.REACT_APP_EWAY_CLIENT_KEY;
